<template>
  <div>
    <div class="view-container end-0 me-2 px-3">
      <div class="col-12 d-flex justify-content-between align-items-end p-0 my-4">
        <div class="body-title">Listado de entradas y salidas</div>
        <div>
          <button type="button" class="btn btn-success" data-bs-toggle="modal" data-bs-target="#addMovModal">
            <i class="fa-solid fa-plus me-2" id="modal-open"></i>
            Añadir
          </button>

        </div>
      </div>

      <div class="content-view">
        <paginate
          ref="paginator"
          name="elements"
          :list="movements"
          :per="15"
          :async="true"
        >
          <div class="col-4 my-2">
            <input
              type="text" class="form-control"
              placeholder="Buscar movimiento"
              v-model="movSearch"
              @keyup="searchMovements()"
            />
          </div>
          <table class="table table-hover">
            <thead class="border-bottom">
              <th class="col">Cant. productos</th>
              <th class="col">Subtotal</th>
              <th class="col">Itbis</th>
              <th class="col">Total</th>
              <th class="col">Fecha creación</th>
            </thead>
            <tbody>
              <tr v-for="(movement, i) in paginated('elements')" :key="i" @click="openModal('editMovement')">
                <td>
                  <div class="col-6 text-end pe-5">{{ movement.product_amount }}</div>
                </td>
                <td>
                  <div class="col-6 text-end">{{ formatNumber(movement.subtotal) }}</div>
                </td>
                <td>
                  <div class="col-6 text-end">{{ formatNumber(movement.taxes) }}</div>
                </td>
                <td>
                  <div class="col-6 text-end">{{ formatNumber(movement.total) }}</div>
                </td>
                <td>
                  <div>{{ dateTimeFormat(movement.created_at) }}</div>
                </td>
              </tr>
            </tbody>
          </table>
        </paginate>
        <div>
          <paginate-links
            for="elements"
            :limit="9"
            :hide-single-page="true"
            :show-step-links="true"
            :step-links="{
              next: '  ❯',
              prev: '❮  '
            }"
          >
          </paginate-links>
        </div>
      </div>

      <!-- Modals -->
      <!-- Add or Edit movements -->
      <div
        class="modal fade"
        id="addMovModal"
        tabindex="-1"
        role="dialog"
        aria-labelledby="myLargeModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title fw-bold">{{ selectedMov.id ? "Editar movimiento" : "Agregar movimiento" }}</h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>

            <div class="modal-body pb-0">
              <!-- Movement Product Select -->
              <div>
                <vSelect
                  multiple
                  :options="products"
                  label="name"
                  :components="{Deselect}"
                  v-model="selectedMov.products"
                  :selectable="(option) => selectableProducts(option)"
                  @option:selecting="(option) => optSelected(option)"
                >
                <!-- No results -->
                <template #no-options="{ search }">
                  No existe ningun producto llamado <strong>"{{search}}"</strong>
                </template>
              </vSelect>
              </div>
              <form class="" @submit.prevent="addMovement()">
                <!-- Movement Product Table -->
                <div>
                  <table class="table table-hover mt-3">
                    <thead class="">
                      <th class="col-4">Producto</th>
                      <th class="col-2">Cantidad</th>
                      <th class="col-2">Itbis</th>
                      <th class="col-2">Precio</th>
                      <th class="col">Total</th>
                    </thead>

                    <tbody class="position-relative">
                      <div v-if="!selectedMov.products.length" class="col-12 position-absolute top-50 start-50 translate-middle">
                        <p class="mt-5 fs-4 text-center">La entrada está vacía</p>
                      </div>

                      <tr
                        v-else
                        v-for="product,i in selectedMov.products" :key="i"
                        :id="`product-row-${i}`"
                        class="align-middle"
                        @mouseenter="addOrRemoveDeleteOptClass($event)"
                        @mouseleave="addOrRemoveDeleteOptClass($event)"
                      >
                        <td>{{ product.name }}</td>
                        <td>
                          <input
                            :id="`productAmount-${i}`" type="number"
                            class="form-control" required
                            v-model="product.quantity"
                            @click="selectText($event)"
                            @focus="selectText($event)"
                            @keydown.enter="enterAsTab($event)"
                            @input="movementTotals(product)"
                          />
                        </td>
                        <td>
                          <CurrencyInput
                            @keydown.enter="enterAsTab"
                            type="text" class="form-control"
                            placeholder="Qty" required
                            v-model="product.taxes"
                            @input="movementTotals(product)"
                          ></CurrencyInput>
                        </td>
                        <td>
                          <CurrencyInput
                            @keydown.enter="enterAsTab"
                            type="text" class="form-control"
                            placeholder="Qty" required
                            v-model="product.price"
                            @input="movementTotals(product)"
                          ></CurrencyInput>
                        </td>
                        <td>{{ formatNumber(product.total) }}</td>
                        <td class="deleteOpt text-danger" @click.stop="confirmMessage(product.id, product)">
                          <i class="bi bi-trash-fill"></i>
                        </td>
                      </tr>

                      <!-- <tr v-if="selectedMov.products.length" class="fw-bold">
                        <td>Total: </td>
                        <td class="text-center">{{ selectedMov.product_amount }}</td>
                        <td class="text-center">{{ selectedMov.taxes }}</td>
                        <td class="text-center">{{ selectedMov.subtotal }}</td>
                        <td class="text-center">{{ selectedMov.total }}</td>
                        <td class="text-center"></td>
                      </tr> -->
                    </tbody>
                  </table>
                </div>

                <div class="modal-footer" :class="!selectedMov.products.length ? 'mt-5' : ''">
                  <button type="submit" class="btn btn-success" data-bs-dismiss="modal" aria-label="Close">
                    {{ selectedMov.id ? "Actualizar producto" : "Agregar movimiento" }}
                  </button>

                  <button
                    id="modal-close"
                    type="button"
                    class="btn btn-danger"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  >
                    Cerrar
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      <!-- invoice Detail -->
      <div
        class="modal fade"
        id="editMovement"
        tabindex="-1"
        role="dialog"
        aria-labelledby="myLargeModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <div>
                <h5 class="modal-title fw-bold" id="exampleModalLabel">Detalle de la factura</h5>
              </div>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>

            <div class="modal-body">
              <table class="table table-bordered border-primary mt-3 position-relative">
                <thead>
                  <th class="col-4">Nombre</th>
                  <th class="col-1 text-center">Cantidad</th>
                  <th class="col-2 text-center">Precio</th>
                  <th class="col-2 text-center">Imp.</th>
                  <th class="col-2 text-center">Total</th>
                </thead>
                <tbody style="line-height: 33px">
                  <tr v-for="(product, i) in selectedMov.products" :key="i">
                    <td>{{ product.name }}</td>
                    <td class="pe-4 text-center">{{ product.pivot.quantity }}</td>
                    <td>
                      <div class="d-flex justify-content-between">
                        <span>RD$</span>
                        <span>{{ product.pivot.price }}</span>
                      </div>
                    </td>
                    <td>
                      <div class="d-flex justify-content-between">
                        <span>RD$</span>
                        <span>{{ product.pivot.taxes }}</span>
                      </div>
                    </td>
                    <td>
                      <div class="d-flex justify-content-between">
                        <span>RD$</span>
                        <span>{{ formatNumber(productTotal(product.pivot.price, product.pivot.quantity)) }}</span>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VuePaginate from "vue-paginate";
import CurrencyInput from "../CurrencyInputComponent.vue";

import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

export default {
  components: {
    vSelect,
    VuePaginate,
    CurrencyInput,
  },
  data() {
    return {
      products: [],
      movements: [],
      selectedMov: {
        id             : null,
        product_amount : "0",
        subtotal       : "0",
        taxes          : "0",
        total          : "0",
        products       : [],
      },
      paginate: ["elements"],
      movSearch: null,

      Deselect: {
        render: (createElement) => {
          return createElement('span', '❌')
        }
      },
    };
  },
  computed:{

  },
  methods: {
    getProducts(){
      axios.get("/invoice/all-products").then((response) => {
        this.products = response.data.products;
      });

    },

    getMovements(){
      axios.get("/movement/all-movements").then((response) => {
        this.movements = response.data.movements;
      });
    },

    selectableProducts(opt){
      return this.selectedMov.products.findIndex(product => product.id == opt.id) < 0
    },

    optSelected(product){
      product['quantity'] = (product.quantity && product.quantity > 0)
        ? product.quantity
        : Vue.set(product, 'quantity', 1)

      this.movementTotals(product, false);
    },

    movementTotals(product, haveToWait = false){
      Vue.set(product, 'total', product.quantity * (+product.taxes + +product.price));

      let product_amount = 0;
      let taxes = 0;
      let subtotal = 0;
      let total = 0;

      setTimeout(() => {
        this.selectedMov.products.forEach(product => {
          product_amount += +product.quantity;
          taxes          += (product.taxes * product.quantity);
          subtotal       += (product.price * product.quantity);
          total          += +product.total;
        })
        this.selectedMov.product_amount = product_amount;
        this.selectedMov.taxes          = taxes;
        this.selectedMov.subtotal       = subtotal;
        this.selectedMov.total          = total ;
      }, (haveToWait) ? 1000 : 0);
    },

    productTotal(price, qty) {
      if (qty == "") {
        qty = 0;
      }
      return isNaN(qty) ? 0 : (price * qty).toFixed(2);
    },

    confirmMessage(id, product) {
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton : "btn btn-success",
          cancelButton  : "ms-2 btn btn-danger",
        },
        buttonsStyling: false,
      });

      swalWithBootstrapButtons.fire({
        title             : "¿Está seguro/a?",
        icon              : "warning",
        showCancelButton  : true,
        confirmButtonText : "Confirmar",
        cancelButtonText  : "Cancelar",
      })
      .then((result) => {
        if (result.isConfirmed) {
          let confirmedPI = this.selectedMov.products.findIndex(p => p.id == product.id);
          if(confirmedPI > -1) this.selectedMov.products.splice(confirmedPI, 1);
        }
      });
    },

    addMovement(){
      axios.post('/movement', this.selectedMov)
      .then((res) => {
        const Toast = Swal.mixin({
          toast: true,
          position: 'top-end',
          timer: 3000,
          showConfirmButton: false,
          timerProgressBar: true,
          didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer)
            toast.addEventListener('mouseleave', Swal.resumeTimer)
          }
        })

        Toast.fire({
          icon: (res.data.success) ? 'success' : 'error',
          title: res.data.success || res.data.error
        });
        // if(res.data.success){
        // }else{
        //   Toast.fire({
        //     icon: 'error',
        //     title: res.data.error
        //   });
        // }
      })
    }
  },
  mounted() {
    this.getProducts();
    this.getMovements();
  },
};
</script>

<style lang="scss" scoped>
  .content-view{
    max-height: 890px !important;
  }
  table.table {
    border-color: #f5f5f5 !important;

    thead {
      th {
        padding: 10px 15px !important;
      }
    }
    tbody {
      p{
        color:var(--first-color-dark) ;
        background: none;
      }
      tr{
        td{
          padding-left: 15px /* !important */;
        }
      }
    }
    // tbody > tr > td {
    // }
  }
</style>
